import {get, post} from '@/api';

export const userApi = {
    // 更新用户设置
    updateUserSettings(data) {
        return post('/user/add-or-update', data);
    },
    
    // 获取聊天设置
    getChatSetting() {
        return get('/user/chat-setting');
    }
};